import { JWT_SECRET, REFRESH_TOKEN_COOKIES, TOKEN_COOKIES } from "@const/shared"
import { GoogleLoginResponse, LoginResponse, RawTokenData, RegisterResponse } from "@interfaces/auth"
import { verifyJwt } from "@lib/functions/jwt"
import nookies, { destroyCookie, setCookie } from "nookies"

export function setTokenCookies(tokenResponse: LoginResponse | RegisterResponse | GoogleLoginResponse) {
  const token = tokenResponse.token
  let tokenData: RawTokenData | undefined

  if (token) {
    const decoded = verifyJwt<RawTokenData>(token, JWT_SECRET)
    if (!decoded) {
      deleteTokenCookies()
    } else {
      setCookie(null, TOKEN_COOKIES, tokenResponse.token, {
        maxAge: 3 * 60 * 60,
        path: "/",
        domain: domainChecker(),
      })

      setCookie(null, REFRESH_TOKEN_COOKIES, tokenResponse.refreshToken, {
        maxAge: 3 * 60 * 60,
        path: "/",
        domain: domainChecker(),
      })
      tokenData = decoded
    }
  }

  return tokenData
}

export function decodedToken(token: string): RawTokenData | null {
  return token ? verifyJwt<RawTokenData>(token, JWT_SECRET) : null
}

export function deleteTokenCookies() {
  const isProduction = process.env.NODE_ENV === "production"

  destroyCookie(null, TOKEN_COOKIES, {
    domain: isProduction
      ? process.env.COOKIES_DOMAIN || process.env.HARISENIN_COOKIES_DOMAIN || ""
      : "",
    path: "/",
  })

  destroyCookie(null, "HS_TEMP")

  destroyCookie(null, REFRESH_TOKEN_COOKIES, {
    domain: isProduction
      ? process.env.COOKIES_DOMAIN || process.env.HARISENIN_COOKIES_DOMAIN || ""
      : "",
    path: "/",
  })
}

export function getTokenInfo(): LoginResponse {
  const cookies = nookies.get({})

  const token = cookies[TOKEN_COOKIES]
  const refreshToken = cookies[REFRESH_TOKEN_COOKIES]

  return { token, refreshToken }
}

export function domainChecker(): string {
  const isProduction = process.env.NODE_ENV === "production"

  if (isProduction) {
    return process.env.COOKIES_DOMAIN || process.env.HARISENIN_COOKIES_DOMAIN || ""
  } else {
    return ""
  }
}
